module.exports = __webpack_public_path__ + "static/media/cookie.af084276.svg";